import * as React from 'react'
import AdjustButton from './AdjustButton'

export type RecordItemProps = {
  item: any
  className?: string
  onAdjust?: (item: any) => void
}

const RecordItem: React.FC<RecordItemProps> = ({ item, className, onAdjust }) => {
  const unit = item.item.default_consumption || item.item.base_unit_of_measure || ''
  const details = [item.item.title, `${item.amount} ${unit}`.trim()].filter(Boolean).join(', ')

  return (
    <div className={`card ${className || ''}`}>
      <div className="card-body p-2 d-flex justify-content-between align-items-center">
        <span>{details}</span>
        {onAdjust && <AdjustButton onClick={() => onAdjust(item)} />}
      </div>
    </div>
  )
}

export default RecordItem
